export default __webpack_public_path__ + "static/media/camera-pdf.6489cc9a.svg";